import React, { Component } from 'react';

import classnames from 'classnames';
import { WithStyles, withStyles } from '@mui/styles';
import APTooltip from "../APToolTip";
import APStatisticStyles from './styles/APStatistic.style';

interface APStatisticProps extends WithStyles<typeof APStatisticStyles> {
  color?: string,
  icon?: any,
  mini?: boolean,
  name: string,
  gaTagToolTips?:string,
  ga4ToolTipTags?:string,
  ga4ModuleNameTag?:string,
  summary: any,
  value: any,
  toolTipMessage?: string
}

class APStatistic extends Component<APStatisticProps, {}> {
  render() {
    const {
      classes,
      color = '#000',
      icon,
      mini,
      name,
      gaTagToolTips,
      ga4ToolTipTags,
      ga4ModuleNameTag,
      summary,
      value,
      toolTipMessage
    } = this.props;

    const containerCls = classnames(classes.container, {
      [classes.miniContainer]: mini
    });

    const textCls = classnames(classes.text, {
      [classes.miniText]: mini
    });

    return (
      <div className={containerCls}>
        {!mini && (
          <span className={classes.value} style={{ backgroundColor: color }}>
            {value}
          </span>
        )}
        <div className={textCls}>
          <span className={classes.name}>
            {mini && <span className={classes.miniValue}>{value}</span>}
            {name}
            {toolTipMessage &&
              <APTooltip
                toolTipMessage={toolTipMessage}
                gaTagToolTips={gaTagToolTips}
                ga4ToolTipTags={ga4ToolTipTags}
                ga4ModuleNameTag={ga4ModuleNameTag}
              />}
          </span>
          <span className={classes.summary}>
            {icon}
            {summary}
          </span>
        </div>
      </div>
    )
  }
}

export default withStyles(APStatisticStyles)(APStatistic);